module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Terminal-3407bd9b742f8b67b5d4ceebe87912a9b52052064a6100970a3065bf1318f3b0.svg";